import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
const FormSecurityApiContext = /*#__PURE__*/React.createContext(undefined);
export const FormSecurityApiProvider = ({
  formSecurityApi,
  children
}) => fg('granular_permissions_on_forms_m1') ? /*#__PURE__*/React.createElement(FormSecurityApiContext.Provider, {
  value: formSecurityApi
}, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
export const useFormSecurityApi = () => {
  if (fg('granular_permissions_on_forms_m1')) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const context = React.useContext(FormSecurityApiContext);
    if (context === undefined) {
      throw new Error('useFormSecurityApi must be used within a FormSecurityApiProvider');
    }
    return context;
  }
  return undefined;
};